import {PagedEndpointList} from '../models/Endpoint';

export const UPDATE_ENDPOINT_LIST = 'UPDATE_ENDPOINT_LIST';

export interface UpdateEndpointListAction {
  type: typeof UPDATE_ENDPOINT_LIST;
  payload: PagedEndpointList;
}

export type EndpointActionTypes = UpdateEndpointListAction;